import { TableNavigation, TablePaper } from 'components/common';
import { ListTable } from 'components/core';
import { useContext } from 'react';
import { ALL_FILTERS } from 'utils/constants/Filters';
import {
  ColumnContext,
  FilterContext,
  ListContext,
  ViewContext,
} from 'utils/context';
import { useDetailsRedirect, usePermissions } from 'utils/hooks';

import { EntityEnum } from '@project44/entity-ui-utils';
import { useTranslation } from '@project44/translations-utils';
import { IOrder } from '@project44-models/shipment-list';

interface IOrdersTable {
  doSearch: () => void;
}

function ListOrders({ doSearch }: IOrdersTable) {
  const handleRedirect = useDetailsRedirect();
  const { clearFilters, hasFilters } = useContext(FilterContext);
  const { savedOrders } = useContext(ViewContext);
  const { t } = useTranslation();
  const { viewColumns } = useContext(ColumnContext);
  const {
    flags: { featureExc2241 },
  } = usePermissions();

  const { doSearchOrders, isErrorOrders, isLoadingOrders, ordersData } =
    useContext(ListContext);

  const onClear = () => {
    clearFilters(ALL_FILTERS);
    doSearch();
  };

  const onPageChange = (page: number) => {
    doSearchOrders({ page, size: 20 });
  };

  const onRowclick = ({ orderId }: IOrder) => {
    handleRedirect(EntityEnum.order, orderId);
  };

  const getTable = () => {
    return (
      <ListTable
        title={t('core.orders')}
        data={ordersData?.results || []}
        doSearch={doSearch}
        handleClear={onClear}
        headers={viewColumns}
        isError={isErrorOrders}
        isLoading={isLoadingOrders || savedOrders.isLoading}
        pagination={{ ...ordersData.paginationInfo, onPageChange }}
        rowClick={onRowclick}
        showClearButton={hasFilters(ALL_FILTERS)}
      />
    );
  };

  const getTablePaper = () => {
    return (
      <TablePaper>
        <TableNavigation
          title={t('core.orders')}
          resultsCount={ordersData.paginationInfo?.total || 0}
          css={{ marginBottom: '$medium' }}
          isLoading={isLoadingOrders}
        />
        {getTable()}
      </TablePaper>
    );
  };

  return featureExc2241 ? getTable() : getTablePaper();
}

export default ListOrders;
